import React from "react";
import hairBleachBanner from "./../../../../../Images/Blog/How Often Should You Bleach Your Hair/Banner.png";

const HairBleachImg = () => {
  return (
    <div className="blogImg-content">
      <img src={hairBleachBanner} alt="hairBleachBanner" loading="lazy" />
    </div>
  );
};

export default HairBleachImg;
